import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Users, Flag, Building2 } from 'lucide-react';
import { cn } from '../../lib/utils';

const TABS = [
  { to: '/admin/leads', label: 'Leads',          icon: Users     },
  { to: '/admin/flags', label: 'Feature Flags',  icon: Flag      },
  { to: '/admin/orgs',  label: 'Organisations',  icon: Building2 },
];

const AdminNav = () => {
  const { pathname } = useLocation();
  return (
    <div className="flex gap-1 border-b mb-5">
      {TABS.map(({ to, label, icon: Icon }) => (
        <Link
          key={to}
          to={to}
          className={cn(
            'flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors',
            pathname.startsWith(to)
              ? 'border-cyan-600 text-cyan-700'
              : 'border-transparent text-gray-500 hover:text-gray-800 hover:border-gray-300'
          )}
        >
          <Icon className="h-3.5 w-3.5" />
          {label}
        </Link>
      ))}
    </div>
  );
};

export default AdminNav;
